import React from 'react';
import AssistantWidget from '@/components/AssistantWidget';
import { LayoutDashboard, FolderKanban, DollarSign, FileText } from 'lucide-react';

/**
 * Placement preview: shows the global floating "Ask DrawReady" widget over a
 * faux dashboard so you can judge how it sits on a real page.
 * Route: /assistant-widget-preview  (mock only)
 */
export default function AssistantWidgetPreview() {
  return (
    <div className="min-h-screen bg-slate-100">
      <div className="bg-amber-50 border-b border-amber-200 text-amber-800 text-xs text-center py-1.5 font-medium">
        Placement preview · the floating button sits on every page (replaces the old chatbot) · tap it bottom-right
      </div>

      {/* Faux app chrome */}
      <div className="flex">
        <aside className="hidden md:flex flex-col w-56 min-h-[calc(100vh-2rem)] bg-[#0b3b6f] text-white/80 p-4 gap-1">
          <div className="text-white font-bold text-lg mb-4 px-2">DrawReady</div>
          {[['Dashboard', LayoutDashboard], ['Projects', FolderKanban], ['Draws', DollarSign], ['Reports', FileText]].map(([l, I], i) => (
            <div key={l} className={`flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm ${i === 0 ? 'bg-white/10 text-white' : ''}`}>
              <I className="w-4 h-4" /> {l}
            </div>
          ))}
        </aside>

        <main className="flex-1 p-6">
          <h1 className="text-2xl font-bold text-slate-900 mb-1">Dashboard</h1>
          <p className="text-sm text-slate-500 mb-6">A sample page — the assistant floats bottom-right everywhere.</p>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
            {[['Active loans', '3'], ['Balance due', '$4,775.12'], ['Available to draw', '$51,408'], ['Subs to pay', '2']].map(([l, v]) => (
              <div key={l} className="bg-white rounded-xl border border-slate-200 p-4">
                <p className="text-[11px] uppercase tracking-wide text-slate-400">{l}</p>
                <p className="text-xl font-bold text-slate-800">{v}</p>
              </div>
            ))}
          </div>
          <div className="bg-white rounded-xl border border-slate-200 h-64 flex items-center justify-center text-slate-300">
            (project content)
          </div>
        </main>
      </div>

      <AssistantWidget />
    </div>
  );
}
